import { mergeClassName as e } from "../../utils/data.js";
import t from "./Row.module.js";
import { jsx as n } from "react/jsx-runtime";
//#region lib/components/Layout/Row.tsx
function r({ children: r, spacing: i = 3, className: a, style: o, ref: s, ...c }) {
	return /* @__PURE__ */ n("div", {
		ref: s,
		...c,
		style: {
			gap: `var(--ag-spacing-${String(i)})`,
			...o
		},
		className: e(t.row, a),
		children: r
	});
}
//#endregion
export { r as Row };
